import * as React from "react"

function InSVG(props) {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <path d="M18.59 24l4.66-.001a.75.75 0 00.75-.75c-.35-7.857 1.842-16.148-6.338-16.148-1.573 0-2.826.537-3.729 1.247 0-1.461-1.579-.653-5.224-.87a.75.75 0 00-.75.75c.302 14.166-.674 15.771.75 15.771h4.66c1.353 0 .492-1.908.75-8.188 0-2.594.75-3.102 2.046-3.102 1.434 0 1.675.996 1.675 3.228.257 6.167-.598 8.063.75 8.063zm-2.425-12.791c-4.491 0-3.546 4.938-3.546 11.29h-3.16V8.978h2.974v1.298c0 .72 1.097 1.074 1.479.35.492-.934 1.77-2.025 3.75-2.025 3.527 0 4.838 1.733 4.838 6.396V22.5h-3.16c0-7.144.756-11.291-3.175-11.291zM1.122 7.479c-1.42 0-.448 1.585-.75 15.771 0 .414.336.75.75.75h4.665c1.42 0 .448-1.585.75-15.771 0-1.295-1.881-.531-5.415-.75zM5.037 22.5H1.872V8.979h3.165zM3.452 0c-4.576 0-4.548 6.929 0 6.929 4.545 0 4.581-6.929 0-6.929zm0 5.429C.884 5.429.86 1.5 3.452 1.5c2.597 0 2.564 3.929 0 3.929z" />
    </svg>
  )
}

export default InSVG
